import './AnalysisResults.css'

function AnalysisResults({ result }) {
  const { overallScore, analysis, suggestions, insights } = result

  return (
    <div className="analysis-results">
      <div className="score-card main-score">
        <div className="score-header">
          <h2>🎯 Overall Analysis Score</h2>
        </div>
        <div className="score-circle">
          <svg viewBox="0 0 200 200">
            <circle
              cx="100"
              cy="100"
              r="85"
              fill="none"
              stroke="rgba(102, 126, 234, 0.2)"
              strokeWidth="12"
            />
            <circle
              cx="100"
              cy="100"
              r="85"
              fill="none"
              stroke="url(#gradient)"
              strokeWidth="12"
              strokeDasharray={`${overallScore * 5.34} 534`}
              strokeLinecap="round"
              transform="rotate(-90 100 100)"
            />
            <defs>
              <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#667eea" />
                <stop offset="100%" stopColor="#764ba2" />
              </linearGradient>
            </defs>
          </svg>
          <div className="score-value">
            <div className="score-number">{overallScore}</div>
            <div className="score-label">/ 100</div>
          </div>
        </div>
        <div className="score-status">
          {overallScore >= 75 ? (
            <span className="status-good">✅ Excellent performance!</span>
          ) : overallScore >= 50 ? (
            <span className="status-medium">⚠️ Room for improvement</span>
          ) : (
            <span className="status-poor">❗ Needs significant work</span>
          )}
        </div>
      </div>

      <div className="analysis-section">
        <h3>📊 Detailed Analysis</h3>
        <div className="analysis-content">
          {analysis}
        </div>
      </div>

      {insights && insights.length > 0 && (
        <div className="insights-section">
          <h3>💡 Key Insights</h3>
          <div className="insights-grid">
            {insights.map((insight, index) => (
              <div key={index} className="insight-card">
                <div className="insight-icon">{insight.icon || '📌'}</div>
                <div className="insight-content">
                  <h4>{insight.title}</h4>
                  <p>{insight.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {suggestions && suggestions.length > 0 && (
        <div className="suggestions-section">
          <h3>🎓 Suggestions for Improvement</h3>
          <div className="suggestions-list">
            {suggestions.map((suggestion, index) => (
              <div key={index} className="suggestion-item">
                <div className="suggestion-number">{index + 1}</div>
                <div className="suggestion-text">{suggestion}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default AnalysisResults

